// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>16</span>&nbsp;&nbsp;Happy are the people whose blessing this is.&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Happy are the people who have the Lord for their God.<br> </p> </div></div>";
// Exports
module.exports = code;